import { prop, formatDate, getSymbolFromCurrency } from '.';
import { __, __r } from 'react-i18n/lib';
import { getImagePath, resolveProductName } from './product';
import * as moment from 'moment';

function getSearchProductInfo(
  product,
  showMoc?: boolean,
  showWithVat?: boolean,
) {
  const currency =
    prop(product, 'currency') || prop(product, 'main_good.currency_id');
  // let price =
  //   prop(product, 'product_detail.main_good.final_price') ||
  //   prop(product, 'main_good_price') ||
  //   prop(product, 'main_good.final_price');
  let price = 0;
  const unit = prop(product, 'main_good.units') || 'ks';
  // const url = `/produkt/${product.product_id}/${product.url}`;
  const url = prop(product, 'product_detail.publish.0.product_url')
    ? prop(product, 'product_detail.publish.0.product_url')
    : prop(product, 'product_publish_url')
    ? `/${prop(product, 'product_publish_url')}`
    : `/${product.url}`;
  const { name, picture, product_id: id } = product;

  let vocPrice = prop(product, 'product_detail.main_good.final_price');

  if (!vocPrice && vocPrice !== 0) {
    vocPrice =
      prop(product, 'main_good_price') ||
      prop(product, 'main_good.final_price');
  }

  let vocPriceNoVat = prop(
    product,
    'product_detail.main_good.final_price_without_vat',
  );
  if (!vocPriceNoVat && vocPriceNoVat !== 0) {
    vocPriceNoVat = prop(product, 'main_good.final_price');
  }

  let mocPrice = prop(product, 'product_detail.main_good.unitprice');
  if (!mocPrice && mocPrice !== 0) {
    mocPrice = prop(product, 'main_good_price');
  }
  if (!mocPrice && mocPrice !== 0) {
    mocPrice = prop(product, 'main_good.unitprice');
  }

  const mocPriceNoVat = prop(
    product,
    'product_detail.main_good.price_without_vat',
  );
  price = showMoc
    ? showWithVat
      ? mocPrice
      : mocPriceNoVat
    : showWithVat
    ? vocPrice
    : vocPriceNoVat;
  if (!showMoc && !price) {
    price = showWithVat ? mocPrice : mocPriceNoVat;
  }

  return {
    currency,
    price: price ? price.toFixed(2) : '',
    unit,
    url,
    id,
    name,
    picture: picture
      ? `${process.env.REACT_APP_API_IMAGE_URL ||
          process.env
            .REACT_APP_API_BASE_URL}/image?query=${picture}&width=160&height=160&webp=0`
      : '/images/icons/placeholder.svg',
  };
}

function getSearchCategoryInfo(category) {
  const {
    category_name,
    url,
    category_id,
    counts,
    parent_categories,
  } = category;
  const lastParent =
    parent_categories && parent_categories.length > 0
      ? parent_categories[parent_categories.length - 1]
      : null;
  const name =
    prop(category, 'publish.0.json_content.name') ||
    prop(category, 'publish.0.category_name') ||
    category_name;

  const correctUrl = prop(category, 'publish.0.url') || url;

  return {
    name,
    url: correctUrl || 'url',
    id: category_id,
    counts,
    lastParent,
  };
}

function getProductDefaultInfo(
  product,
  apiUrl?,
  showMoc?: boolean,
  showWithVat?: boolean,
) {
  const currency =
    prop(product, 'currency') || prop(product, 'main_good.currency.name');
  const publish = prop(product, 'publish', '');
  const ordernr = prop(product, 'main_good.order_number', '');
  const onStock =
    prop(product, 'main_good_stock_count', 0) ||
    prop(product, 'main_good.on_stock_count', 0);
  const availid =
    prop(product, 'main_good_availability.avail_id') ||
    prop(product, 'main_good.availability.avail_id', 11);
  const availability =
    prop(
      product,
      'product_detail.main_good.availability.translations.0.avail_name',
    ) ||
    prop(product, 'main_good.availability.translations.0.avail_name') ||
    prop(product, 'main_good_availability.avail_uniqid') ||
    prop(product, 'main_good.availability.avail_uniqid', 'Nedostupné');
  const oldPrice =
    prop(product, 'product_detail.main_good.oldprice') ||
    prop(product, 'main_good.oldprice');
  const oldPriceCorporate = prop(
    product,
    'product_detail.main_good.corporate_price_old',
  );
  const finalOldPriceCorporate = oldPriceCorporate; // oldPrice > 0 ? oldPrice : oldPriceCorporate;
  let vocPrice = prop(product, 'product_detail.main_good.final_price');

  if (!vocPrice && vocPrice !== 0) {
    vocPrice =
      prop(product, 'main_good_price') ||
      prop(product, 'main_good.final_price');
  }

  let vocPriceNoVat = prop(
    product,
    'product_detail.main_good.final_price_without_vat',
  );
  if (!vocPriceNoVat && vocPriceNoVat !== 0) {
    vocPriceNoVat = prop(product, 'main_good.final_price_without_vat');
  }

  let mocPrice = prop(product, 'product_detail.main_good.final_price');
  if (!mocPrice && mocPrice !== 0) {
    mocPrice = prop(product, 'main_good_price');
  }
  if (!mocPrice && mocPrice !== 0) {
    mocPrice = prop(product, 'main_good.unitprice');
  }
  const mocPriceNoVat = prop(
    product,
    'product_detail.main_good.final_price_without_vat',
  );
  let price = showMoc
    ? showWithVat
      ? mocPrice
      : mocPriceNoVat
    : showWithVat
    ? vocPrice
    : vocPriceNoVat;
  if (!showMoc && !price) {
    price = showWithVat ? mocPrice : mocPriceNoVat;
  }
  const unit = prop(product, 'main_good.helios_units');
  // const url = `/produkt/${product.product_id}/${product.url}`;
  const url = prop(product, 'product_detail.publish.0.product_url')
    ? `/${prop(product, 'product_detail.publish.0.product_url')}`
    : prop(product, 'publish.0.product_url')
    ? `/${prop(product, 'publish.0.product_url')}`
    : prop(product, 'product_publish_url')
    ? `/${prop(product, 'product_publish_url')}`
    : `/${prop(product, 'url')}`;
  const { name, picture, product_id: id, issaleout, is_new, is_sale } = product;
  const productId = prop(product, 'product_id');
  const isNew = prop(product, 'is_new') || prop(product, 'isnew');
  const isSale = prop(product, 'main_good.sale');
  const isFavorite = prop(product, 'is_favorite');
  const salePercentage =
    prop(product, 'product_detail.main_good.sale_percentage') ||
    prop(product, 'main_good.sale_percentage');
  let goodId = prop(product, 'main_good.good_id');
  if (!goodId) {
    goodId = prop(product, 'main_good_id');
  }
  const plu = prop(product, 'product_plu', '') || prop(product, 'plu');
  const brand = prop(product, 'brand.brand_name', '');
  const description =
    prop(product, 'product_detail.publish.0.product_description') ||
    // prop(product, 'product_detail.product_descr') ||
    prop(
      product,
      'publish.0.product_description',
      prop(product, 'description'),
    ) ||
    prop(product, 'description');
  const variants = prop(product, 'product_detail.product_connections')
    ? prop(product, 'product_detail.product_connections').filter(
        pc => pc.connection_type === 'COLORS',
      )
    : [];
  const isSaleB2b =
    prop(product, 'main_good_sale_b2b') || prop(product, 'main_good.sale_b2b');
  const isSaleB2c =
    prop(product, 'main_good_sale_b2c') || prop(product, 'main_good.sale_b2c');

  const isSecondHand = prop(product, 'product_parent_id');
  const isFreeDelivery = prop(product, 'is_free_delivery');
  const giftSaleData = prop(product, 'giftData');
  const cartSaleData = prop(product, 'saleData');
  const currentSales =
    prop(product, 'current_sales') ||
    prop(product, 'product_detail.current_sales');

  const condition = prop(product, 'product_detail.product_condition');
  const isWaiting =
    prop(product, 'is_waiting') || prop(product, 'product_detail.is_waiting');
  
  const hiddenSale =  prop(product, 'product_detail.main_good.hidden_sale_by_domain'); 

  const forbiddenOrder = prop(product, 'product_detail.forbidden_order');
  const forbiddenOrderValid = prop(product, 'product_detail.forbidden_order_valid');
  const forbiddenOrderByDate = !!(forbiddenOrder && (
    forbiddenOrderValid == null ||
    (moment(forbiddenOrderValid).isValid() &&
     moment(forbiddenOrderValid).isSameOrAfter(moment(),'day'))
  ));

  return {
    giftSaleData,
    cartSaleData,
    variants,
    description,
    ordernr,
    onStock,
    availid,
    goodId,
    availability,
    oldPrice,
    oldPriceCorporate: finalOldPriceCorporate,
    price,
    unit,
    url,
    id,
    name:
      prop(product, 'publish.0.product_name') ||
      prop(product, 'product_detail.publish.0.product_name') ||
      name,
    imagePath: picture,
    picture: picture
      ? `${process.env.REACT_APP_API_IMAGE_URL ||
          process.env
            .REACT_APP_API_BASE_URL}/image?query=${picture}&width=160&height=160&webp=0`
      : '/images/icons/placeholder.svg',
    pictureWebP: picture
      ? `${process.env.REACT_APP_API_IMAGE_URL ||
          process.env
            .REACT_APP_API_BASE_URL}/image?query=${picture}&width=160&height=160&webp=1`
      : '/images/icons/placeholder.svg',
    isNew,
    isSale,
    isFavorite,
    salePercentage,
    currency,
    publish,
    plu,
    productId,
    issaleout,
    is_new,
    issale: is_sale,
    brand,
    isSaleB2b,
    isSaleB2c,
    isSecondHand,
    isFreeDelivery,
    condition,
    isWaiting,
    currentSales,
    hiddenSale,
    forbiddenOrderByDate,
    forbiddenOrderValid
  };
}

function getArticleDefaultInfo(article) {
  const url = `/${article.url}`;
  const { name: title, image: picture } = article;
  const date = prop(article, 'date', '')
    ? formatDate(prop(article, 'date', ''), 'DD.MM.YYYY')
    : formatDate(prop(article, 'created_date', ''), 'DD.MM.YYYY');
  const anotation = prop(article, 'json_content.anotation', '');
  const categoryName = 'Kategoria';
  const author = prop(article, 'author.name');

  return {
    url,
    title,
    date,
    anotation,
    categoryName,
    pictureSrc: picture,
    picture: picture
      ? `${process.env.REACT_APP_API_IMAGE_URL ||
          process.env
            .REACT_APP_API_BASE_URL}/image?query=${picture}&width=656&height=492&webp=0&type=cover`
      : '/images/icons/placeholder.svg',
    pictureWebP: picture
      ? `${process.env.REACT_APP_API_IMAGE_URL ||
          process.env
            .REACT_APP_API_BASE_URL}/image?query=${picture}&width=656&height=492&webp=1&type=cover`
      : '/images/icons/placeholder.svg',
    author,
  };
}

function getArticleDetailInfo(article) {
  const title = prop(article, 'name', '');
  const date = formatDate(prop(article, 'created_date', ''), 'DD.MM.YYYY');
  const category = prop(article, 'category', '');
  const content = prop(article, 'json_content.body', '');
  const downloads = prop(article, 'downloads', []);
  const products = prop(article, 'products', []);

  return {
    title,
    date,
    category,
    content,
    downloads,
    products,
  };
}

function getInvoiceDetailInfo(invoice) {
  const invoiceNr = prop(invoice, 'invoiceNr', '');
  const sumPrice = prop(invoice, 'sumPrice', '');
  const invoicePath = prop(invoice, 'invoicePath', null);
  const invoiceFileName = prop(invoice, 'invoiceFileName', '');
  const notPaid = prop(invoice, 'notPaid');

  return {
    invoiceNr,
    sumPrice,
    invoicePath,
    invoiceFileName,
    notPaid,
  };
}

function getOrderRowInfo(order) {
  const ordernr = prop(order, 'outer_id', '') || '';
  const status = prop(order, 'order_status_readable', '');
  const sumPrice = prop(order, 'order_tprice', '');
  const date = formatDate(
    prop(order, 'created_datetime', null),
    'DD.MM.YYYY HH:mm:ss',
  );
  const id = prop(order, 'outer_id', '');
  const statusColor = prop(order, 'order_status_color', '');
  const orderPublicId = prop(order, 'public_id', '');
  const currency = prop(order, 'order_tpricecurrency');

  return {
    id,
    date,
    status,
    sumPrice,
    ordernr,
    statusColor,
    orderPublicId,
    currency,
  };
}

function getOrderItemRowInfo(product) {
  const ordernr = prop(product, 'outer_id', '') || '';
  const status = prop(product, 'order_status_readable', '');
  const sumPrice = prop(product, 'order_tprice', '');
  const date = formatDate(
    prop(product, 'created_datetime', null),
    'DD.MM.YYYY HH:mm:ss',
  );
  const id = prop(product, '_id', '');
  const statusColor = prop(product, 'order_status_color', '');
  const orderPublicId = prop(product, 'public_id', '');
  const currency = prop(product, 'order_tpricecurrency');
  const picture = prop(product, 'picture');
  const name = resolveProductName(product);
  const plu = prop(product, 'plu');
  const availid =
    prop(product, 'main_good_availability.avail_id') ||
    prop(product, 'main_good.availability.avail_id', 11);
  const availability =
    prop(
      product,
      'product_detail.main_good.availability.translations.0.avail_name',
    ) ||
    prop(product, 'main_good_availability.avail_uniqid') ||
    prop(product, 'main_good.availability.avail_uniqid', 'Nedostupné');

  return {
    id,
    date,
    status,
    sumPrice,
    ordernr,
    statusColor,
    orderPublicId,
    currency,
    picture,
    name,
    plu,
    availid,
    availability,
  };
}

function getRequestRowInfo(request) {
  const requestNr = prop(request, 'requestNr', '');
  const yourNr = prop(request, 'yourNr', '-') || '-';
  const statusReadable = prop(request, 'order_status_readable', '');
  const status = prop(request, 'order_status', '');
  const date = formatDate(
    prop(request, 'created_datetime', null),
    'DD.MM.YYYY HH:mm:ss',
  );
  const id = prop(request, 'order_id', '');
  const publicId = prop(request, 'public_id', '');
  const url = `${__r(
    'routes:moj-ucet/dopyty',
    '/moj-ucet/dopyty',
  )}/${publicId}`;

  return {
    id,
    date,
    status,
    statusReadable,
    requestNr,
    yourNr,
    url,
  };
}

function getRequestDetailInfo(request) {
  const requestId = prop(request, 'order_nr', '');
  const vs = prop(request, 'vs', '-') || '-';
  const yourNr = prop(request, 'yourNr', '-') || '-';
  const orderStatusReadable = prop(request, 'order_status_readable', '');
  const items = prop(request, 'items', '');
  const totalPrice = prop(request, 'order_tprice', 0);
  const totalPriceWithoutVat = prop(request, 'order_tprice_without_vat', 0);
  const currency = getSymbolFromCurrency(
    prop(request, 'order_tpricecurrency', 'EUR'),
  );
  const vat = totalPrice - totalPriceWithoutVat;

  return {
    orderId: requestId,
    vs,
    orderStatusReadable,
    items,
    yourNr,
    totalPrice: totalPrice ? totalPrice.toFixed(2) : 0,
    totalPriceWithoutVat: totalPriceWithoutVat
      ? totalPriceWithoutVat.toFixed(2)
      : 0,
    vat: vat ? vat.toFixed(2) : 0,
    currency,
  };
}

function getOrderDetailInfo(order) {
  const orderNr = prop(order, 'outer_id', '') || '';
  const orderStatusReadable = prop(order, 'order_status_readable', '');
  const items = prop(order, 'items', []);
  const totalPrice = prop(order, 'order_tprice', 0);
  const totalPriceWithoutVat = prop(order, 'order_tprice_without_vat', 0);
  const discount = prop(order, 'discount', 0);
  const currency = getSymbolFromCurrency(
    prop(order, 'order_tpricecurrency', 'EUR'),
  );
  const vatRate = prop(order, 'payment.vat_rate', 20);
  const vat = totalPrice - totalPriceWithoutVat;
  const phone = prop(order, 'person.phone', '');
  const email = prop(order, 'person.email', '');
  const company = prop(order, 'company.name', '');
  const street = prop(order, 'address.street', '');
  const streetNr = prop(order, 'address.street_number', '');
  const city = prop(order, 'address.city', '');
  const zip = prop(order, 'address.zip', '');
  const deliveryCompany = prop(order, 'delivery.delivery_firm', '');
  const deliveryStreet = prop(order, 'delivery.delivery_addr_street', '');
  const deliveryStreetNr = prop(
    order,
    'delivery.delivery_addr_street_number',
    '',
  );
  const deliveryCity = prop(order, 'delivery.delivery_addr_city', '');
  const deliveryZip = prop(order, 'delivery.delivery_addr_zip', '');
  const deliveryType = prop(order, 'delivery.delivery_typename', '');
  const deliveryPrice = prop(order, 'delivery.delivery_price', 0);
  const deliveryPriceWithoutVat = deliveryPrice;
  const paymentType = prop(order, 'payment.payment_typename', '');
  const invoiceLink = prop(order, 'documents.faktura', '');
  const itemsPrice = items
    .filter(i => !i.is_meta_item)
    .reduce(
      (total, item) => total + item.totalprice_without_vat * item.quantity,
      0,
    );
  const itemsPriceWithoutVat = itemsPrice / (1 + vatRate / 100);

  const note = prop(order, 'comments', '');
  const customOrderNr = prop(order, 'order_note', '');

  const totalItemsPrice = prop(order, 'total_items_price');

  return {
    customOrderNr,
    note,
    itemsPrice,
    itemsPriceWithoutVat,
    orderNr,
    orderStatusReadable,
    items,
    totalPrice: totalPrice ? totalPrice.toFixed(2) : 0,
    totalPriceWithoutVat: totalPriceWithoutVat
      ? totalPriceWithoutVat.toFixed(2)
      : 0,
    discount,
    vatRate,
    vat: vat ? vat.toFixed(2) : 0,
    currency,
    phone,
    email,
    company,
    street,
    streetNr,
    city,
    zip,
    deliveryCompany,
    deliveryStreet,
    deliveryStreetNr,
    deliveryCity,
    deliveryZip,
    deliveryType,
    deliveryPrice,
    deliveryPriceWithoutVat,
    paymentType,
    invoiceLink,
    totalItemsPrice,
  };
}

function getRequestDetailItemInfo(item) {
  const quantity = prop(item, 'quantity', 0);
  const ordernr = prop(item, 'ordernr', '');
  const name = prop(item, 'product_name', '');
  const note = prop(item, 'product_note', '');
  const currency = getSymbolFromCurrency(prop(item, 'currency', 'EUR'));
  const totalPriceWithoutVat = prop(item, 'totalprice_without_vat', 0);
  const unitprice = prop(item, 'unitprice', 0);
  const picture = prop(item, 'product_picture');
  const image = picture
    ? `https://beta.zemplin.sk/api/v1/image?query=${picture}&width=48&height=48&webp=0`
    : '/images/icons/placeholder.svg';

  return {
    quantity,
    ordernr,
    name,
    note,
    image,
    currency,
    totalPriceWithoutVat: totalPriceWithoutVat
      ? totalPriceWithoutVat.toFixed(2)
      : 0,
    unitprice: unitprice ? unitprice.toFixed(2) : 0,
  };
}

function getCartItemInfo(item, isCorporate: boolean = false) {
  const saleCount = prop(item, 'sale_count', 0);
  const totalCount = prop(item, 'total_count', 0);
  const quantity = prop(item, 'count', 1);
  const saleQuantity = prop(item, 'sale_count', 1);
  const ordernr = prop(item, 'product.plu', '');
  const name =
    prop(item, 'product.publish.0.product_name', '') ||
    prop(item, 'product.name', '');
  const currency = getSymbolFromCurrency(prop(item, 'good.currency_id', 'EUR'));
  const totalPrice = prop(item, 'sum_price', 0);
  const totalSalePrice = prop(item, 'sum_sale_price', 0);

  const unitprice = prop(item, 'good.unitprice', 0);
  const finalPrice = prop(item, 'good.final_price', 0);
  const finalSalePrice = totalSalePrice / saleQuantity;
  const picture = prop(item, 'product.picture', '');
  const image =
    picture && picture !== ''
      ? `${process.env.REACT_APP_API_IMAGE_URL ||
          process.env
            .REACT_APP_API_BASE_URL}/image?query=${picture}&width=160&height=160&webp=0`
      : '/images/icons/placeholder.svg';
  const availability =
    prop(item, 'good.availability.avail_name', '') ||
    prop(item, 'good.availability.avail_uniqid', '');
  const availId = prop(item, 'good.availability.avail_id', '');
  const productId = prop(item, 'product.product_id', '');
  const goodId = prop(item, 'good.good_id', '');
  const isNew = prop(item, 'product.is_new', '');

  // const url = prop(item, 'product.url', '');

  let productUrl: string =
    prop(item?.product?.publish[0], 'product_url') || `${item?.product?.url}`;

  if (productUrl && productUrl[0] != '/') {
    productUrl = `/${productUrl}`;
  }

  const currencyId = prop(item, 'good.currency_id', 'EUR');

  const totalPriceWithoutVat = prop(item, 'sum_price_without_vat', 0);
  const finalPriceWithoutVat = prop(item, 'good.final_price_without_vat', 0);

  const totalSalePriceWithoutVat = prop(item, 'sum_sale_price_without_vat', 0);
  const finalSalePriceWithoutVat = totalSalePriceWithoutVat / saleQuantity;

  const subItems = prop(item, 'sub_items', []);
  const units = prop(item, 'good.units', 'ks');
  const oldPrice = prop(item, 'good.oldprice', null);
  const isSecondHand = !!item?.good?.parent_good_id;
  const hiddenSale = !!item?.good?.hidden_sale_by_domain;

  const corporatePrice = prop(item, 'good.corporate_price', 0);
  const corporatePriceOld = prop(item, 'good.corporate_price_old', 0);
  
  const isSale = isCorporate?corporatePriceOld >corporatePrice :oldPrice > unitprice;
  const isFreeDelivery = prop(item.product, 'sales')
  ? !!prop(item.product, 'sales').find((s) => s.name === 'FREE_DELIVERY_DSI')
  : false;

  const currentSales = prop(item.product, 'current_sales');
  const hasGift = !!currentSales?.length;

  return {
    quantity,
    saleQuantity,
    ordernr,
    name,
    image,
    currency,
    currencyId,
    finalPrice,
    finalSalePrice,
    totalPrice,
    totalSalePrice,
    unitprice,
    availability,
    availId,
    productId,
    goodId,
    productUrl,
    totalPriceWithoutVat,
    finalPriceWithoutVat,
    totalSalePriceWithoutVat,
    finalSalePriceWithoutVat,
    subItems,
    units,
    saleCount,
    totalCount,
    oldPrice,
    isNew,
    isSecondHand,
    hiddenSale,
    isSale,
    isFreeDelivery,
    hasGift
  };
}

function getOrderDetailItemInfo(item) {
  const quantity = prop(item, 'quantity', 1);
  const ordernr = prop(item, 'outer_id', '') || '';
  const name = prop(item, 'product_name', '');
  const currency = getSymbolFromCurrency(prop(item, 'currency', 'EUR'));
  const totalPriceWithoutVat = prop(item, 'totalprice_without_vat', 0);
  const unitPriceWithoutVat = prop(item, 'unitprice_without_vat', 0);

  const outerPayload = prop(item, 'good_details_json.outer_payload');
  const unitprice = prop(item, 'good_details_json.unitprice.excludeVat', 0);
  const picture = prop(item, 'product_picture', '');
  const image =
    picture && picture !== ''
      ? `${process.env.REACT_APP_API_IMAGE_URL ||
          process.env
            .REACT_APP_API_BASE_URL}/image?query=${picture}&width=160&height=160&webp=0`
      : '/images/icons/placeholder.svg';
  const productId = prop(item, 'product_id', '');
  const url = prop(item, 'product_url', '');
  const productUrl = url ? `/${url}` : '';

  return {
    outerPayload,
    quantity,
    ordernr,
    name,
    image,
    currency,
    totalPriceWithoutVat: totalPriceWithoutVat
      ? totalPriceWithoutVat.toFixed(2)
      : 0,
    unitprice: unitprice ? unitprice.toFixed(2) : 0,
    productId,
    url,
    productUrl,
    unitPriceWithoutVat,
  };
}

function getDeliveryAddressInfo(address) {
  const deliveryStreet = prop(address, 'delivery_street', '');
  const deliveryNumber = prop(address, 'delivery_number', '');
  const deliveryZip = prop(address, 'delivery_zip', '');
  const deliveryCity = prop(address, 'delivery_city', '');
  const country =
    prop(address, 'country', '') === 'sk'
      ? 'Slovensko'
      : prop(address, 'country', '');
  const id = prop(address, 'id', '');
  const isDefault = prop(address, 'isDefault', false);
  const name = prop(address, 'name', '');
  const surname = prop(address, 'surname', '');
  const phone = prop(address, 'delivery_phone', '');

  return {
    deliveryStreet,
    deliveryNumber,
    deliveryZip,
    deliveryCity,
    country,
    id,
    isDefault,
    name,
    surname,
    phone,
  };
}

function getCartSummaryInfo(data, user?: any) {
  const isB2B = user && user.b2b;
  const totalPrice = prop(data, 'total_price', 0);
  const totalItemsPrice = prop(data, 'total_items_price', 0);
  const totalItemsPriceWithoutVat = prop(
    data,
    'total_items_price_without_vat',
    0,
  );

  const totalItemsPriceBeforeGiftcards = prop(
    data,
    'total_items_price_before_giftcards',
    0,
  );
  const totalItemsPriceWithoutVatBeforeGiftcards = prop(
    data,
    'total_items_price_without_vat_before_giftcards',
    0,
  );

  const totalPriceWithoutVat = prop(data, 'total_price_without_vat', 0);
  const vatTotal = totalPrice - totalPriceWithoutVat;
  const currency = getSymbolFromCurrency(prop(data, 'currency', 'EUR'));
  const deliveryPrice = isB2B
    ? prop(data, 'delivery.price.priceWithoutVat', 0)
    : prop(data, 'delivery.price.price', 0);
  const paymentPrice = isB2B
    ? prop(data, 'payment.price.priceWithoutVat', 0)
    : prop(data, 'payment.price.price', 0);
  const vatGroups = prop(data, 'vat_groups');
  const giftCardDiscount = prop(data, 'total_giftcards_price');
  const nominalGiftCards = prop(data, 'giftcards', []).filter(
    giftcard => giftcard.is_nominal,
  );
  const lang = prop(data, 'lang');

  return {
    lang,
    totalPrice,
    totalPriceWithoutVat: totalPriceWithoutVat
      ? totalPriceWithoutVat.toFixed(2)
      : 0,
    totalItemsPriceBeforeGiftcards,
    totalItemsPriceWithoutVatBeforeGiftcards: totalItemsPriceWithoutVatBeforeGiftcards
      ? totalItemsPriceWithoutVatBeforeGiftcards.toFixed(2)
      : 0,
    vatTotal: vatTotal ? vatTotal.toFixed(2) : 0,
    currency,
    deliveryPrice,
    paymentPrice,
    totalItemsPrice: totalItemsPrice ? totalItemsPrice : 0,
    totalItemsPriceWithoutVat: totalItemsPriceWithoutVat
      ? totalItemsPriceWithoutVat
      : 0,
    vat_groups: vatGroups,
    giftCardDiscount,
    nominalGiftCards,
  };
}

function getAccountRowInfo(account) {
  const id = prop(account, 'id', '');
  const name = prop(account, 'meno', '');
  const surname = prop(account, 'priezvisko', '');
  const email = prop(account, 'email', '');
  const orders = prop(account, 'orders', 0);
  const requests = prop(account, 'requests', 0);

  return {
    id,
    name,
    surname,
    email,
    orders,
    requests,
  };
}

export const resolveCategoryUrlFromCategory = (category, byId) => {
  if (category.weburl && !category.redirect_category_id) {
    const redirectType =
      category.weburl.startsWith('/') || category.weburl.startsWith('https')
        ? 'URL'
        : 'CATEGORYTEXT/URL';
    return resolveCategoryUrl(
      category.redirect_category_id,
      category.weburl,
      redirectType,
    );
  } else {
    return category.weburl
      ? resolveCategoryUrl(
          category.redirect_category_id,
          prop(byId, `${category.redirect_category_id}.publish.0.url`) ||
            category.weburl,
          'CATEGORYTEXT/URL',
        )
      : resolveCategoryUrl(
          category.category_id,
          prop(category, 'publish.0.url') || category.url || 'url',
          'CATEGORYTEXT/URL',
        );
  }
};

export const resolveCategoryUrl = (
  id: string | number,
  url: string,
  format?: string,
  lang?: string
): string => {
  if (format === 'CATEGORYTEXT/ID/URL') {
    return `${__r('routes:kategoria', '/kategoria')}/${id}/${url}`;
  } else if (format === 'CATEGORYTEXT/URL') {
    return `${__r('routes:kategoria', '/kategoria', lang)}/${url}`;
  } else if (format === 'URL') {
    return `${url}`;
  } else {
    return `${__r('routes:kategoria', '/kategoria')}/${id}/${url}`;
  }
};

export const resolveProductUrl = (id: string | number, url: string): string => {
  return `/${url ? url : 'url'}`;
  // return `/produkt/${id}/${url ? url : 'url'}`;
};

export const getProductDetailInfo = (product, apiUrl?) => {
  const currency = prop(product, 'main_good.currency.name', '');
  const publish = prop(product, 'publish', '');
  const description = prop(product, 'publish.0.content.json_content.body', '');
  const annotation = prop(
    product,
    'publish.0.content.json_content.annotation',
    '',
  );
  const plu = prop(product, 'product_plu', '');
  const ean = prop(product, 'product_ean', '');
  const availid = prop(product, 'main_good.availability.avail_id', 11);
  const availability =
    prop(product, 'main_good.availability.translations.0.avail_name') ||
    prop(product, 'main_good.availability.avail_uniqid', 'Nedostupné');
  const oldPrice = prop(product, 'main_good.oldprice');
  const oldPriceCorporate = prop(product, 'main_good.corporate_price_old');
  const finalOldPriceCorporate = oldPriceCorporate; // oldPrice > 0 ? oldPrice : oldPriceCorporate;
  const oldPriceReal = prop(product, 'main_good.oldprice_real');
  const price = prop(product, 'main_good.final_price');
  const mocPrice = prop(product, 'main_good.unitprice');
  const mocPriceWithoutVat = prop(product, 'main_good.price_without_vat');
  const priceWithoutVat = prop(product, 'main_good.final_price_without_vat');
  const unit =
    prop(product, 'main_good.helios_units') ||
    prop(product, 'main_good.units', 'ks') ||
    'ks';
  // const url = `/produkt/${product.product_id}/${product.url}`;
  const url = `/${prop(product, 'url')}`;
  const name =
    prop(product, 'publish.0.product_name', '') || prop(product, 'name', '');
  const picture = prop(product, 'picture');
  const id = prop(product, 'product_id');
  const brandAttrib = prop(product, 'attribs')
    ? prop(product, 'attribs').find(a => a.attrib_name === 'Značka')
    : {};
  const brand =
    prop(brandAttrib, 'values.0.translations.0.attrib_value') ||
    prop(brandAttrib, 'values.0.attrib_value') ||
    prop(product, 'brand.brand_name', '');
  const brandImage = prop(product, 'brand.brand_image', '');
  const brandProvider = prop(product, 'brand.brand_provider', '');
  const brandId = prop(product, 'brand.brand_id', '');
  const brandUrl = prop(product, 'brand.url', '');

  const sale = prop(product, 'main_good.sale');
  const salePercentage = prop(product, 'main_good.sale_percentage');
  const salePercentageReal = prop(product, 'main_good.sale_percentage_real');
  const photogallery = prop(product, 'photogallery');
  const isSale = prop(product, 'main_good.sale');

  const isSaleB2b = prop(product, 'main_good.sale_b2b');
  const isSaleB2c = prop(product, 'main_good.sale_b2c');

  const isNew = prop(product, 'isnew');
  const condition = prop(product, 'product_condition');
  const onStockCount = prop(product, 'main_good.on_stock_count');
  const parentProductId =
    prop(product, 'parent_product_id', false) ||
    prop(product, 'product_parent_id', false);
  const isFreeDelivery = prop(product, 'sales')
    ? !!prop(product, 'sales').find(s => s.name === 'FREE_DELIVERY_DSI')
    : false;
  const isWaiting =
    !!prop(product, 'is_waiting') || prop(product, 'product_detail.is_waiting');
  
  const hiddenSale =  prop(product, 'main_good.hidden_sale_by_domain');
  const forbiddenOrder = prop(product, 'forbidden_order');
  const forbiddenOrderValid = prop(product, 'forbidden_order_valid');
  const forbiddenOrderByDate = !!(forbiddenOrder && (
    forbiddenOrderValid == null ||
    (moment(forbiddenOrderValid).isValid() &&
     moment(forbiddenOrderValid).isSameOrAfter(moment(),'day'))
  ));

  return {
    currency,
    publish,
    annotation,
    description,
    plu,
    ean,
    availid,
    availability,
    oldPrice,
    oldPriceCorporate: finalOldPriceCorporate,
    oldPriceReal,
    price,
    mocPrice,
    mocPriceWithoutVat,
    priceWithoutVat,
    unit,
    url,
    id,
    name,
    image: picture,
    brand,
    brandImage,
    brandProvider,
    brandId,
    brandUrl,
    sale,
    salePercentage,
    salePercentageReal,
    photogallery,
    isSale,
    isNew,
    isSaleB2b,
    isSaleB2c,
    condition,
    onStockCount,
    parentProductId,
    isFreeDelivery,
    productId: prop(product, 'product_id', ''),
    goodId: prop(product, 'main_good.good_id', ''),
    shortDesc: prop(product, 'publish.0.product_description'),
    isWaiting,
    hiddenSale,
    forbiddenOrderByDate,
    forbiddenOrderValid
  };
};

const getDownloadFileInfo = download => {
  const id = prop(download, 'document_id', '');
  const path = prop(download, 'document_path');
  const name = prop(download, 'document_name', '');
  const fullPath = `https://beta.zemplin.sk/api/v1/file?query=${path}`;

  return { id, name, path: fullPath };
};

function getProductSmallInfo(product) {
  const { picture } = product;
  return {
    picture: picture
      ? `https://beta.zemplin.sk/api/v1/image?query=${picture}&width=80&height=80&webp=0`
      : '/images/icons/placeholder.svg',
  };
}

function getRelatedProductInfo(product, apiUrl?) {
  const currency = prop(product, 'main_good.currency.name', '');
  let description = prop(
    product.publish[0],
    'content.json_content.short_description',
    '',
  );

  if (!description) {
    description = prop(product.publish[0], 'product_description', '');
  }

  const price = prop(product, 'main_good.final_price');
  // const url = `/produkt/${product.product_id}/${product.url}`;
  let url: string =
    prop(product?.publish[0], 'product_url') || `/${product.url}`;
  if (url && url[0] != '/') {
    url = `/${url}`;
  }

  const { name, picture, product_id: id } = product;

  const onStockCount = prop(product, 'main_good.on_stock_count');
  const availid = prop(product, 'main_good.availability.avail_id', 11);
  const availability =
    prop(product, 'main_good.availability.translations.0.avail_name') ||
    prop(product, 'main_good.availability.avail_uniqid', 'Nedostupné');
  const isNew = prop(product, 'isnew');
  const condition = prop(product, 'product_condition');
  const isWaiting = prop(product, 'is_waiting', false);

  return {
    price,
    url,
    id,
    name,
    picture: picture
      ? getImagePath(picture, { width: 136, height: 136 })
      : '/images/icons/placeholder.svg',
    currency,
    description,
    onStockCount,
    availid,
    availability,
    isNew,
    condition,
    isWaiting,
  };
}

export const getElasticCategoryProductInfo = product => {
  const priceWithoutVat = prop(product, 'main_good_price');
  const unit = prop(product, 'main_good_units') || 'ks';

  const onStock = prop(product, 'main_good_stock_count', 0);
  const availability =
    prop(product, 'availability', 0) === 1 ? 'Skladom' : 'Nedostupné';
  const oldPrice = prop(
    product,
    'main_good.oldprice',
    prop(product, 'main_good.unitprice'),
  );
  const price = prop(product, 'main_good_price');
  const {
    name,
    picture,
    product_id: id,
    product_publish_url,
    issaleout,
    is_new,
    is_sale,
  } = product;
  // const url = `/produkt/${id}/${product_publish_url}`;
  const url = `/${product_publish_url}`;
  const goodId = prop(product, 'main_good_id');

  return {
    onStock,
    availability,
    oldPrice,
    price,
    priceWithoutVat,
    unit,
    url,
    productId: id,
    name,
    issaleout,
    is_new,
    issale: is_sale,
    goodId,
    ordernr: '',
    picture: picture
      ? `https://beta.zemplin.sk/api/v1/image?query=${picture}&width=160&height=160&webp=0`
      : '/images/icons/placeholder.svg',
  };
};

function getCartProductAvailabilityInfo(product, countInCart) {
  const onStock = prop(product, 'good.on_stock_count', 0);
  const availText = prop(product, 'availability.avail_uniqid', '');
  const orderAvailable = prop(product, 'availability.order_available', 0);

  const correctAvailText =
    orderAvailable && onStock < countInCart
      ? __('Čiastočne skladom')
      : availText;
  const color =
    correctAvailText === __('Čiastočne skladom')
      ? '#FFA454'
      : correctAvailText === 'Skladom'
      ? '#2DCC8D'
      : '#FF2D58';
  return { availText: correctAvailText, color, onStock };
}

function getCartProductInfo(product, apiUrl?: string) {
  const currency = prop(product, 'good.currency_id', 'EUR');
  const ordernr = prop(product, 'good.order_number', '');
  const onStock = prop(product, 'good.on_stock_count', 0);
  const count = prop(product, 'count');
  const productNote = prop(product, 'product_note');
  const sumPrice = prop(product, 'sum_price', 0);

  const {
    name,
    picture,
    product_id: id,
    issaleout,
    isnew,
    issale,
  } = product.product;
  const productId = prop(product, 'product.product_id');
  const goodId = prop(product, 'good.good_id');
  // const url = `/produkt/${productId}/${product.product.url}`;
  const url = `/${product.product.url}`;

  return {
    count,
    currency,
    ordernr,
    onStock,
    sumPrice: sumPrice ? sumPrice.toFixed(2) : 0,
    url,
    id,
    name,
    issaleout,
    is_new: isnew,
    issale,
    productId,
    goodId,
    productNote,
    picture: picture
      ? `${
          apiUrl ? apiUrl : 'https://beta.zemplin.sk/api/v1'
        }/image?query=${picture}&width=160&height=160&webp=0`
      : '/images/icons/placeholder.svg',
  };
}

const getFinishedOrderInfo = order => {
  const orderNr = prop(order, 'outer_id', '');
  const name = prop(order, 'person.name');
  const surname = prop(order, 'person.surname', '');
  const phone = prop(order, 'person.phone', '');
  const publicId = prop(order, 'public_id', '');

  return {
    orderNr,
    name,
    surname,
    phone,
    publicId,
    ...getOrderDeliveryInfo(order),
  };
};

const getOrderDeliveryInfo = order => {
  const city = prop(
    order,
    'delivery.delivery_addr_city',
    prop(order, 'address.city'),
  );
  const street = prop(
    order,
    'person.delivery_addr_street',
    prop(order, 'address.street'),
  );
  const streetNumber = prop(
    order,
    'person.delivery_addr_street_number',
    prop(order, 'address.street_number'),
  );
  const zip = prop(
    order,
    'person.delivery_addr_zip',
    prop(order, 'address.zip'),
  );
  const country = prop(
    order,
    'person.delivery_addr_country',
    prop(order, 'address.country'),
  );

  return { city, country, streetNumber, street, zip };
};

const getOtherTextInfo = otherText => {
  const description = prop(otherText, 'content.json_content.body', '');
  let name = prop(otherText, 'content.json_content.name', '');
  if (!name.length) {
    name = prop(otherText, 'text_name', '');
  }

  return {
    description,
    name,
  };
};

const getProductBaseInfo = product => {
  const publish = prop(product, 'publish', [])[0];
  const description = prop(publish, 'product_description', '');

  return {
    description,
  };
};

function getCategoryDefaultInfo(category) {
  const url = resolveCategoryUrl(category.category_id, category.url);
  const { category_name: title, image: picture } = category;
  return {
    title,
    url,
    picture: picture
      ? `https://beta.golfcentrum.sk/api/v1/image?query=${picture}&width=328&height=248&webp=0`
      : '/images/icons/placeholder.svg',
    pictureWebP: picture
      ? `https://beta.golfcentrum.sk/api/v1/image?query=${picture}&width=328&height=248&webp=1`
      : '/images/icons/placeholder.svg',
  };
}

const getCartItemData = item => {
  const { idx, count, sum_price: price, total_count } = item;
  // const name = prop(item, `product.name`, '');
  // const url = `/produkt/${prop(item, `product.product_id`)}/${prop(
  //   item,
  //   `product.url`,
  // )}`;
  const url = `/${prop(item, `product.url`)}`;
  const picture = prop(item, `product.picture`, null);
  const name = prop(item, `product.name`, null);
  const currency = prop(item, `good.currency_id`, 'EUR');
  const attrib = '';

  return {
    idx,
    count,
    price,
    url,
    currency,
    attrib,
    name,
    picture: picture
      ? `${process.env.REACT_APP_API_IMAGE_URL ||
          process.env
            .REACT_APP_API_BASE_URL}/image?query=${picture}&width=68&height=68&webp=0&type=cover`
      : '/images/icons/placeholder.svg',
  };
};

export {
  getSearchProductInfo,
  getSearchCategoryInfo,
  getProductDefaultInfo,
  getArticleDefaultInfo,
  getArticleDetailInfo,
  getInvoiceDetailInfo,
  getOrderRowInfo,
  getRequestRowInfo,
  getDeliveryAddressInfo,
  getAccountRowInfo,
  getCartSummaryInfo,
  getDownloadFileInfo,
  getProductSmallInfo,
  getRequestDetailItemInfo,
  getOrderDetailItemInfo,
  getCartItemInfo,
  getRequestDetailInfo,
  getOrderDetailInfo,
  getCartProductAvailabilityInfo,
  getCartProductInfo,
  getFinishedOrderInfo,
  getRelatedProductInfo,
  getOtherTextInfo,
  getProductBaseInfo,
  getCategoryDefaultInfo,
  getCartItemData,
  getOrderItemRowInfo,
};
